export default "__VITE_ASSET__Djnz9oDy__"